import script from "./DetailLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailLayout.vue?vue&type=script&setup=true&lang=js"

import "./DetailLayout.vue?vue&type=style&index=0&id=38ef1444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ef1444"]])

export default __exports__